/*
 * ParticipantDetailControls.jsx 16.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import {withRouter} from 'react-router';
import { Redirect } from 'react-router-dom';
import {compose, graphql} from 'react-apollo';

import ParticipantDetailFrame from '../../components/detail/ParticipantDetailFrame';
import compareAsc from 'date-fns/compare_asc';
import getParticipantByIdQuery from '../../queries/getParticipantById.graphql';


const withParticipant = graphql(getParticipantByIdQuery, {
    options: params => ({
        variables: {teilnehmerId: parseInt(params.match.params.id, 10)},
        fetchPolicy: 'network-only',
        pollInterval: 60000
    }),
    props: ({ownProps, data}) => {


        if (data.loading || !data.getTeilnehmerById) {
            return {
                participantLoading: data.loading,
                participant: null,
                refetchParticipant: data.refetch
            };
        }

        if (data.error) {
            return {hasErrors: true, participant: null};
        }

        return {
            participant: data.getTeilnehmerById,
            refetchParticipant: data.refetch,
            ...ownProps
        };
    }
});

class ParticipantDetailControls extends React.Component {

    /**
     * Registriert einen Listener "focus": Wenn das Browser-Fenster in den Vordergrund geholt wird,
     * dann sollen die Daten des fokussierten Teilnehmers aktualisiert werden.
     */
    constructor() {
        super();
        this.focusListener = this.refetchParticipant.bind(this);
        window.addEventListener('focus', this.focusListener);
    }

    /**
     * Deregistriert den Listener auf das Browser-Fenster, wenn die Komponente abgeräumt wird.
     */
    componentWillUnmount() {
        window.removeEventListener('focus', this.focusListener);
    }

    /**
     * Löst einen Apollo-Refetch der Daten eines Teilnehmers aus.
     */
    refetchParticipant() {
        this.props.refetchParticipant();
    }

    render() {
        const { participant, participantLoading } = this.props;

        if (!participant && participantLoading) {
            return null;

        } else if (!participant) {
            return <Redirect to={`/`} />;
        }

        const goalList = this.props.participant.ziele.slice().sort((a, b) => compareAsc(a.ende, b.ende));

        if (goalList.length > 0 && !this.props.match.params.goalId) {
            return (
                <Redirect to={`/participant/${this.props.participant.id}/${goalList[0].id}`} />
            );
        }

        const selectedGoal = goalList.find(g => g.id === this.props.match.params.goalId);


        return (
            <ParticipantDetailFrame participant={participant} goalList={goalList} selectedGoal={selectedGoal} />
        );
    }
}

export default withRouter(compose(withParticipant)(ParticipantDetailControls));



// WEBPACK FOOTER //
// ./src/de/ergovia/containers/detail/ParticipantDetailControls.js